import React, { useState } from 'react';
import { I18n } from '@aws-amplify/core';
import { DownOutlined } from '@ant-design/icons';
import { Collapse } from 'antd';

import { CATEGORY_SCORES } from '@/components/views/Report/KimLhc/Report/Steps/Result/Constants';
import { CategoryRenderer } from '@/components/views/Report/KimLhc/Report/Steps/Result/categories';
import { CategoryHeader } from './CategoryHeader';

import type { KimLhcCategories } from '@/types';
import * as S from '@/components/views/Report/KimLhc/Report/Steps/Result/styles';

const { Panel } = Collapse;

interface CategoryScoresProps {
	categories: KimLhcCategories;
}

export function CategoryScores({ categories }: Readonly<CategoryScoresProps>) {
	const [activeKeys, setActiveKeys] = useState<string[]>([]);

	const hasOpenPanels = activeKeys.length > 0;

	function handleCollapseAll() {
		setActiveKeys([]);
	}

	function handleCollapseChange(keys: string | string[]) {
		setActiveKeys(keys as string[]);
	}

	function renderExpandIcon({ isActive }: { isActive?: boolean }) {
		return <DownOutlined rotate={isActive ? 180 : 0} />;
	}

	return (
		<>
			<S.AccordionHeaderContainer>
				<S.AccordionTitle>{I18n.get('Score by category')}</S.AccordionTitle>
				{hasOpenPanels && (
					<S.CloseAllButton onClick={handleCollapseAll}>{I18n.get('Close all')}</S.CloseAllButton>
				)}
			</S.AccordionHeaderContainer>
			<S.StyledCollapse
				expandIconPosition="end"
				expandIcon={renderExpandIcon}
				activeKey={activeKeys}
				onChange={handleCollapseChange}
			>
				{CATEGORY_SCORES.map((category, index) => (
					<Panel
						key={index.toString()}
						header={<CategoryHeader category={category} categories={categories} />}
					>
						<CategoryRenderer category={category.contentKey} categories={categories} />
					</Panel>
				))}
			</S.StyledCollapse>
		</>
	);
}
